import { Component, OnInit, ViewChild } from '@angular/core';
import { EmployeeDataTableService } from './employee-data-table.service';
import { ExcelService } from 'src/app/services/excel-service.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserRoles } from 'src/app/consts/gsdRoles.const'
import { MatDialog } from '@angular/material/dialog';
import { auto } from '@popperjs/core';
import { Console } from 'console';
import { data } from 'jquery';
import { DateRangeDialogComponentComponent } from 'src/app/components/confirmation-back-dialog/date-range-dialog-component/date-range-dialog-component';
import { Toast, ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
export enum Level {
  Beginner = 1,
  Intermediate,
  Expert
}
@Component({
  selector: 'app-employee-data-table',
  templateUrl: './employee-data-table.component.html',
  styleUrls: ['./employee-data-table.component.css']
})
export class EmployeeDataTableComponent implements OnInit {
  displayedColumns = ["employeeId", "firstName", "lastName", "email", "competency", "subCompetency", "resume", "role", "yearsOfExperience" , "updatedOn"];
  loading: boolean = true;
  searchText: string = "";
  roleFilter: string = "";
  exportexcel : boolean = false;
  isProfileCompleted: boolean = true;
  from: any = 0;
  size: any = 10;
  totalRecords: any = 0;
  currentPage: Number = 0;
  userRoles = UserRoles;
  totalCertificates: Number;
  public dataSource: MatTableDataSource<any>;
  public profileCompletedCounts: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private service: EmployeeDataTableService, private toaster: ToastrService, private excel: ExcelService, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.getEmployeeData();
    this.getProfileCompletedCounts();
  }
  exportExcel(isProfileCompleted, size) {
    this.service.getEmployeeProfilesByStatuses("", isProfileCompleted, 0, size).subscribe(x => {
 
      const excelData = x.data.items.map(i => {
        const years = Math.floor(i.experience ?? 0);
        const months = Math.round(((i.experience ?? 0) - years) * 12);
        i['Employee Id'] = i.employeeId;
        i['First Name'] = i.firstName;
        i['Last Name'] = i.lastName;
        i['Email'] = i.email;
        i['Experience'] = `${years} yr(s) ${months} mo(s)`;
        i['Competency'] = i.competency;
        i['Sub Competency'] = i.subCompetency;
        i['Resume status'] = i.resume ? (i.resume.name ? 'Uploaded' : 'Not Uploaded') : 'Not Uploaded';
        i['Planned Certifications'] = i.plannedCertificateNames ? i.plannedCertificateNames.join(', ') : '';
        i['Completed Certifications'] = i.completedCertificateNames ? i.completedCertificateNames.join(', ') : '';
        i['Areas of Expertise'] = i.serviceAreas ? i.serviceAreas.join(', ') : '';
        i['Domain Expert'] = i.domains ? i.domains.join(', ') : '';
        if (i.primarySkills && i.primarySkills.length > 0) {
          i['Primary Skills'] = i.primarySkills.map(skill => {
            return `${skill.skill}`;
          }).join(', ');
        } else {
          i['Primary Skills'] = '';
        }
        if (i.secondarySkills && i.secondarySkills.length > 0) {
          i['Secondary Skills'] = i.secondarySkills.map(skill => {
            return `${skill.skill}`;
          }).join(', ');
        } else {
          i['Secondary Skills'] = '';
        }
        i['Country'] = i.country;
        i['Updated On'] = i.updatedOn;
        i['Updated By'] = i.updatedBy; 
        // if (isProfileCompleted === true) {
        //   if (i.resumeDownloadUrl && i.resumeDownloadUrl.trim() !== "") {
        //     i['Resume'] = `=HYPERLINK("${i.resumeDownloadUrl}", "Resume Link")`;
        //   }
        //    else {
        //     i
        //     ['Resume'] = "Not available";            
        //   }
        // }

        if (isProfileCompleted === '') {
          i['Role'] = i.role[0];
        }
        
        delete i.employeeId;
        delete i.firstName;
        delete i.lastName;
        delete i.email;
        delete i.competency;
        delete i.subCompetency;
        delete i.resume;
        delete i.certificateNames;
        delete i.serviceAreas;
        delete i.domains;
        delete i.primarySkills;
        delete i.secondarySkills;
        delete i.country;
        delete i.updatedBy
        delete i.updatedOn 
        delete i.isProfileCompleted;
        delete i.role;
        delete i.plannedCertificateNames;
        delete i.completedCertificateNames;
        delete i.allSkills;
        delete i.competencyId;
        delete i.subCompetencyId;
        delete i.serviceArea;
        delete i.experience;
          // delete i.resumeDownloadUrl;


        return i;
      });
console.log('x.Data', excelData);
      if (excelData.length !== 0) {         
        let fileName = ''
        if (isProfileCompleted === true) {
          fileName = 'Completed_Employees'
        } else if (isProfileCompleted === false) {
          fileName = 'Not_Started_Employees'
        } else {
          fileName = "Employees_With_Role"
        }
        this.excel.exportAsExcelFile(excelData, fileName);
      }
      else {
        this.toaster.error("No data available to export");
      } 
    });
  }
  exportExcelForCertificate() {
    this.service.getEmployeeCertificationDetails().subscribe(x => {
      let excelData = x.data.items.flatMap(employee => {
        const plannedCertificates = employee.plannedCertificateNames?.map(cert => ({
          EmployeeId: employee.employeeId,
          FirstName: employee.firstName,
          LastName: employee.lastName,
          Email: employee.email,
          CertificateName: cert?.name,
          Status: 'Planned',
          CertificateLevel: Level[cert.certificateLevel],
          PlannedDate: cert?.date?.split('T')[0],
        }));
        const completedCertificates = employee.completedCertificateNames?.map(cert => ({
          EmployeeId: employee.employeeId,
          FirstName: employee.firstName,
          LastName: employee.lastName,
          Email: employee.email,
          completedCertificates: cert.name,
          Status: 'Completed',
          CertificateLevel: Level[cert.certificateLevel],
          completedDate: cert.date?.split('T')[0],
          ExpiryDate: cert.expiryDate?.split('T')[0]
        }));

        return [...plannedCertificates, ...completedCertificates];
      });
      let fileName = 'Employee_Certificate_Details'
      this.excel.exportAsExcelFile(excelData, fileName);
    });
  }
  openDatesTemplate() {
    const dialogRef = this.dialog.open(DateRangeDialogComponentComponent, {
      width: auto,
      minWidth: '500px',
      height: auto,
      //data: { Title: "Warning!", Content: "You have unsaved data. Do you want to continue?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.getGSDStats(result.data[0], result.data[1]).subscribe(res => {
          var excel = [{
            EmployeeCount: res.data.employeeCount,
            ProposalCount: res.data.proposalCount,
            CaseStudiesCount: res.data.caseStudiesCount,
            TemplateCount: res.data.templateCount,
            CertificateCount: res.data.certificateCount
          }];
          this.excel.exportAsExcelFile(excel, "GSDStats");

        }
        );
      }
      else {
        this.toaster.error("Data not uploaded from the selected date");
      }
    });
  }
  getEmployeeData() {
    this.loading = true;
    return this.service.getEmployeeProfilesByStatuses(this.searchText, this.isProfileCompleted, this.from, this.size, this.roleFilter).subscribe(x => {
    x.data.items.forEach(emp => {
      if (emp.experience != null) {
       emp.expYears = Math.floor(emp.experience); 
       emp.expMonths = Math.round((emp.experience - emp.expYears) * 12);

      } else {
        emp.expYears = 0;
        emp.expMonths = 0;
      }
    });
      this.dataSource = new MatTableDataSource(x.data.items);
      this.dataSource.sort = this.sort;
      this.totalRecords = x.data.total;
      this.loading = false;
    });
  }
  /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */

  getdata() {
    this.currentPage = 0;
    this.from = 0;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.size = this.paginator.pageSize;
    }

    this.getEmployeeData();
  }
  getPaginatorData(event) {
    if (event.previousPageIndex > event.pageIndex) {
      this.from = (event.pageIndex * this.size);
      this.size = event.pageSize;
    }
    else {
      this.size = event.pageSize;
      this.from = (event.pageIndex * this.size);
    }
    this.getEmployeeData();
  }

  getProfileCompletedCounts() {
    this.loading = true;
    this.service.getProfileCompletedCounts().subscribe(x => {
      this.profileCompletedCounts = x.data;
      this.loading = false;
    })
  }
  applyFilter(filterValue: string) {
    if (filterValue.length > 2 || filterValue.length == 0) {
      if (filterValue.includes('@')) {
        filterValue = filterValue.substring(0, filterValue.indexOf("@"));
      }
      this.searchText = filterValue;
      this.from = 0;
      this.currentPage = 0;
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
      this.getEmployeeData();
    }
  }

  filterByRole(role: string) {
    this.roleFilter = role;
    this.from = 0; 
    this.currentPage = 0; 
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.getEmployeeData();
  }
}



